module.exports = __webpack_public_path__ + "static/media/launch.feed1f86.png";